module.exports = __webpack_public_path__ + "img/icon_xiaoxi.6a8208f1.png";